<template>
  <div>
    <input
      v-model="song.title"
      class="input title"
      type="text"
      placeholder="Title"
      @input="update('title', $event.target.value)"
    >
    <div class="field">
      <b-taginput
        v-model="song.song.tags"
        ellipsis
        placeholder="Add a tag"
        icon="label"
        autocomplete
        :data="displayedTags"
        field="name"
        @input="update('song.tags', $event)"
        @typing="getFilteredTags"
      />
    </div>
    <textarea
      v-model="song.lyrics"
      v-autosize
      class="textarea"
      placeholder="Lyrics"
      @input="update('lyrics', $event.target.value)"
    />
  </div>
</template>

<script>
import Vue from "vue";
import autosize from "autosize";
import { cloneDeep } from "lodash";
import { mapState, mapActions } from "vuex";

Vue.directive("autosize", {
  bind: function(el) {
    Vue.nextTick(function() {
      var tagName = el.tagName;
      if (tagName == "TEXTAREA") {
        autosize(el);
      }
    });
  },
  componentUpdated: function(el) {
    Vue.nextTick(function() {
      var tagName = el.tagName;
      if (tagName == "TEXTAREA") {
        autosize.update(el);
      }
    });
  },
  unbind: function(el) {
    autosize.destroy(el);
  }
});

export default {
  props: {
    initialSong: Object
  },
  data() {
    return {
      song: cloneDeep(this.initialSong),
      displayedTags: []
    };
  },
  computed: {
    ...mapState(["tags"])
  },
  beforeMount() {
    this.$store.dispatch("fetchTags");
  },
  mounted() {
    this.fetchTags().then(tags => {
      this.displayedTags = tags.filter(
        tag => !this.song.song.tags.map(t => t.name === tag.name).includes(true)
      );
    });
  },
  methods: {
    update(path, value) {
      this.$emit("update", {
        path,
        value
      });
    },
    filterUsedTags() {
      return this.tags.list.filter(
        tag => !this.song.song.tags.map(t => t.name === tag.name).includes(true)
      );
    },
    getFilteredTags(name) {
      this.displayedTags = this.filterUsedTags().filter(tag =>
        tag.name.toLowerCase().includes(name.toLowerCase())
      );
    },
    ...mapActions(["fetchTags"])
  }
};
</script>

<style lang="scss">
.song-tags {
  margin-bottom: 1.5rem;
}
.tag:not(body).is-add {
  margin-left: 1px;
  padding: 0;
  position: relative;
  width: 2em;
  &:hover {
    background-color: #e8e8e8;
  }
  &::before {
    height: 2px;
    width: 50%;
  }
  &::after {
    height: 50%;
    width: 2px;
  }
  &::before,
  &::after {
    background-color: currentColor;
    content: "";
    display: block;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    transform-origin: center center;
  }
}
</style>



// WEBPACK FOOTER //
// SongEdit.vue?7c36a2c4